import { cn } from "@/lib/utils";
import { usePermissions } from "components/permissions/usePermissions";
import { Button } from "components/ui/button";
import { announcementBannerDismissedPrefix } from "data/local-storage-keys";
import { X } from "lucide-react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { getLocalStorage, setLocalStorage } from "utils/local-storage";
import { dashboardAnnouncement } from "./dashboard-announcement";

export const AnnouncementBanner = () => {
  const history = useHistory();
  const { isPermitted, isPermissionsSuccess } = usePermissions();
  const {
    id,
    icon: Icon,
    title,
    description,
    appearance,
    action,
  } = dashboardAnnouncement;
  const dismissalStorageKey = `${announcementBannerDismissedPrefix}${id}`;
  const [dismissed, setDismissed] = useState(() =>
    getLocalStorage(dismissalStorageKey, false),
  );
  if (dismissed) return null;

  const dismiss = () => {
    setLocalStorage(dismissalStorageKey, true);
    setDismissed(true);
  };

  return (
    <div
      data-testid="announcement-banner"
      className={cn(
        "flex items-center gap-3 rounded-lg py-2.5 pr-2.5 pl-3.5",
        appearance.backgroundClassName,
        appearance.foregroundClassName,
      )}
    >
      <span className="flex size-7 shrink-0 items-center justify-center rounded-md">
        <Icon className="size-6" />
      </span>
      <p className="min-w-0 flex-1 text-sm">
        <span className="font-medium">{title}</span>{" "}
        <span className="font-semibold">{description}</span>
      </p>
      <div className="flex shrink-0 items-center gap-1">
        {action &&
          (!action.permission ||
            (isPermissionsSuccess && isPermitted([action.permission]))) && (
            <Button
              variant="link"
              data-testid="announcement-banner-cta"
              onClick={() => history.push(action.to)}
              className={cn(
                "text-sm font-semibold",
                appearance.foregroundClassName,
              )}
            >
              {action.label} →
            </Button>
          )}
        <Button
          variant="ghost"
          size="icon"
          aria-label="Dismiss"
          data-testid="announcement-banner-dismiss"
          onClick={dismiss}
          className={appearance.foregroundClassName}
        >
          <X />
        </Button>
      </div>
    </div>
  );
};
